"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6159],{

/***/ 5049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TabIconButton; },
/* harmony export */   "Y": function() { return /* binding */ TabButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17573);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78296);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 700;\n            color: ",
        " !important;\n            border-color: ",
        " !important;\n            b,\n            strong {\n              font-weight: 700;\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 300;\n            color: ",
        ";\n            b,\n            strong {\n              font-weight: 300;\n            }\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    display: flex;\n    align-items: center;\n\n    min-width: min-content;\n    min-height: 26px;\n\n    font-size: 13px;\n    line-height: 21px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    white-space: nowrap;\n\n    transition: all 0.2s ease;\n\n    color: ",
        ";\n    border-bottom: 1rpx solid\n      ",
        ";\n\n    ",
        " {\n      font-size: 14px;\n      padding-bottom: 6px;\n    }\n\n    br {\n      display: none;\n    }\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n      border-color: currentColor;\n    }\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    min-width: 24px;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var TabButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__/* .CleanButton */ .ux).withConfig({
    displayName: "TabButton",
    componentId: "sc-71a4751e-0"
})(_templateObject2(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.primary;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .transparentize */ .DZ)(0.6, theme.text.palette.primary);
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), function(param) {
    var $active = param.$active;
    return $active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    }), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    })) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.heavy;
    }));
});
var TabIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(TabButton).withConfig({
    displayName: "TabButton__TabIconButton",
    componentId: "sc-71a4751e-1"
})(_templateObject3());


/***/ }),

/***/ 16001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ScrollToSectionOnClick; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63085);
/* harmony import */ var src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47631);







var ScrollToSectionOnClick = function(_param) {
    var children = _param.children, id = _param.id, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "offset"
    ]);
    var ref;
    var layoutRegisterContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__/* .LayoutRegisterContext */ .D);
    var scrollToSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(px) {
        var section = document === null || document === void 0 ? void 0 : document.querySelector("#".concat(id));
        if (section != null) {
            var ref;
            var _fixed;
            window.scrollTo({
                top: section.getBoundingClientRect().top + window.scrollY - offset * px - ((_fixed = (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed) !== null && _fixed !== void 0 ? _fixed : 0) * px,
                behavior: "smooth"
            });
        }
    }, [
        id,
        offset,
        (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed
    ]);
    var clickCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e, px) {
        var _props, ref, ref1;
        (ref = (_props = children.props).onClick) === null || ref === void 0 ? void 0 : ref.call(_props, e);
        (ref1 = props.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(props, e);
        scrollToSection(px);
    }, [
        children.props,
        props,
        scrollToSection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveUnit */ .D, {
        children: function(px) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                onClick: function(e) {
                    return clickCallback(e, px);
                }
            }));
        }
    });
};


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TabsSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79017);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16001);
/* harmony import */ var src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5049);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71008);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15201);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .swiper-slide {\n    min-width: min-content;\n    width: auto;\n  }\n  .swiper-wrapper {\n    gap: 20px;\n    max-width: max-content;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var SwiperContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__/* .ConstraintContainer */ .a).withConfig({
    displayName: "TabsSwiper__SwiperContainer",
    componentId: "sc-69bd32eb-0"
})(_templateObject());
var TabsSwiperComponent = function(param) {
    var tabs = param.tabs, activeTab = param.activeTab, scrollOffset = param.scrollOffset, buttonClassName = param.buttonClassName, setActiveTab = param.setActiveTab;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_10__.useTranslate)()._;
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (swiperRef.current) {
            var ref;
            (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideTo(tabs.findIndex(function(param) {
                var id = param.id;
                return id === activeTab;
            }));
        }
    }, [
        tabs,
        activeTab
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperContainer, {
        as: swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t,
        slidesPerView: "auto",
        threshold: 10,
        onSwiper: function(swiper) {
            return swiperRef.current = swiper;
        },
        children: tabs.map(function(tab) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o, {
                children: tab.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__/* .TrackedLink */ .A, {
                    href: tab.link,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        className: buttonClassName,
                        as: "a",
                        $active: activeTab === tab.id,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__/* .ScrollToSectionOnClick */ .d, {
                    id: tab.id,
                    offset: scrollOffset,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        $active: activeTab === tab.id,
                        className: buttonClassName,
                        onClick: function() {
                            return setActiveTab === null || setActiveTab === void 0 ? void 0 : setActiveTab(tab.id);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                })
            }, tab.id);
        })
    });
};
var TabsSwiper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(TabsSwiperComponent);


/***/ }),

/***/ 51306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 1.5;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p.withConfig({
    displayName: "Text__Paragraph",
    componentId: "sc-ee167d0d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});


/***/ }),

/***/ 84147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55537);





var Play = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_2__/* .IconBox */ .zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 0L64.1773 32L16 64V0ZM21.3589 9.9927V54.0073L54.4918 32L21.3589 9.9927Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Play);


/***/ }),

/***/ 76424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ EventsGridGallery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/components/common/DirectusImage.tsx
var DirectusImage = __webpack_require__(52520);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/components/common/FormatDate.tsx
var FormatDate = __webpack_require__(23955);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/components/icons/Play.tsx
var Play = __webpack_require__(84147);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsGridGallery/EventsGridGalleryItemVideos.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: ",
        ";\n  white-space: nowrap;\n  background: transparent;\n  transition: 0.25s;\n  border-radius: 20px;\n  padding: 4px 8px 4px 12px;\n  margin-right: -6px;\n  ",
        " {\n    padding: 4px 12px 4px 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 23px;\n  height: 23px;\n  padding: 4px;\n  border-radius: 50%;\n  border: 1rpx solid currentColor;\n  margin: 0 0 0 9px;\n  ",
        " {\n    margin: 0 9px 0 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var EventCardVideosLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsGridGalleryItemVideos__EventCardVideosLabel",
    componentId: "sc-4addfc7d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, theme/* dirRTL */.gX);
var PlayIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsGridGalleryItemVideos__PlayIcon",
    componentId: "sc-4addfc7d-1"
})(_templateObject1(), theme/* dirRTL */.gX);
var EventsGridGalleryItemVideos = function(param) {
    var relatedVideos = param.relatedVideos;
    var _n = (0,lib.useTranslate)()._n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        initial: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
            theme: theme/* redTheme */.MN,
            children: !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : relatedVideos.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                fade: true
            })), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventCardVideosLabel, {
                    children: [
                        _n("{count} video", "{count} videos", relatedVideos.length, undefined, {
                            count: "".concat(relatedVideos.length)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Play/* default */.Z, {
                                size: 9
                            })
                        })
                    ]
                })
            }))
        })
    });
};

// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
// EXTERNAL MODULE: ./src/modules/events/hooks/useEventRelatedVideosListQuery.ts
var useEventRelatedVideosListQuery = __webpack_require__(98310);
// EXTERNAL MODULE: ./src/modules/events/hooks/useFlattenEvent.ts
var useFlattenEvent = __webpack_require__(73082);
// EXTERNAL MODULE: ./src/hooks/useTimeState.ts
var useTimeState = __webpack_require__(12597);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsGridGallery/EventsGridGalleryItem.tsx

function EventsGridGalleryItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  padding-left: 18px;\n  padding-right: 18px;\n\n  ",
        " {\n    width: 300px;\n  }\n"
    ]);
    EventsGridGalleryItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventsGridGalleryItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% + 36px);\n  margin-left: -18px;\n  margin-right: -18px;\n  padding: 18px;\n\n  position: relative;\n  color: ",
        ";\n  background: ",
        ";\n\n  margin-bottom: 16px;\n  height: 200px;\n\n  ",
        " {\n    margin-bottom: 18px;\n    height: 324px;\n  }\n"
    ]);
    EventsGridGalleryItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n\n  ",
        " {\n    object-position: center center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 150%;\n  white-space: nowrap;\n  margin-right: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  font-weight: 300;\n  line-height: 1;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  font-weight: 200;\n  line-height: 1;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n  max-width: 100%;\n  word-wrap: break-word;\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 18px 0 0;\n\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n\n  ",
        ";\n\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  letter-spacing: 0.64rpx;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    ",
        " {\n      background: ",
        ";\n      color: ",
        ";\n      backdrop-filter: blur(16rpx);\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


















var Container = (0,styled_components_browser_esm["default"])(motion/* motion.li */.E.li).withConfig({
    displayName: "EventsGridGalleryItem__Container",
    componentId: "sc-70106cb5-0"
})(EventsGridGalleryItem_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Card = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsGridGalleryItem__Card",
    componentId: "sc-70106cb5-1"
})(EventsGridGalleryItem_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var theme = param.theme, $background = param.$background;
    return $background !== null && $background !== void 0 ? $background : theme.palette.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var BackgroundImage = (0,styled_components_browser_esm["default"])(DirectusImage/* DirectusImage */.q).withConfig({
    displayName: "EventsGridGalleryItem__BackgroundImage",
    componentId: "sc-70106cb5-2"
})(_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var CardContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsGridGalleryItem__CardContent",
    componentId: "sc-70106cb5-3"
})(_templateObject3());
var EventsGridGalleryItem_Date = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsGridGalleryItem__Date",
    componentId: "sc-70106cb5-4"
})(_templateObject4());
var Name = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "EventsGridGalleryItem__Name",
    componentId: "sc-70106cb5-5"
})(_templateObject5());
var Title = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "EventsGridGalleryItem__Title",
    componentId: "sc-70106cb5-6"
})(_templateObject6(), (0,common/* lineClamp */.Sf)(3));
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventsGridGalleryItem__Description",
    componentId: "sc-70106cb5-7"
})(_templateObject7(), (0,common/* lineClamp */.Sf)(3));
var Tags = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventsGridGalleryItem__Tags",
    componentId: "sc-70106cb5-8"
})(_templateObject8(), (0,common/* lineClamp */.Sf)(2), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
});
var TagsTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventsGridGalleryItem__TagsTitle",
    componentId: "sc-70106cb5-9"
})(_templateObject9());
var CardTop = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsGridGalleryItem__CardTop",
    componentId: "sc-70106cb5-10"
})(_templateObject10());
var CardLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "EventsGridGalleryItem__CardLink",
    componentId: "sc-70106cb5-11"
})(_templateObject11(), EventCardVideosLabel, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.5, theme.palette.background);
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var animationConfig = {
    hide: {
        opacity: 0,
        y: 10
    },
    show: {
        opacity: 1,
        y: 0
    }
};
var EventsGridGalleryItem = function(param) {
    var event = param.event;
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,useEventRelatedVideosListQuery/* useEventRelatedVideosListQuery */.w)({
        event: event
    }), relatedVideos = ref.data;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    var link = (0,react.useMemo)(function() {
        if ((relatedVideos === null || relatedVideos === void 0 ? void 0 : relatedVideos.length) === 1) {
            return route/* route.video */.BC.video(relatedVideos[0]).page();
        }
        if (Number(relatedVideos === null || relatedVideos === void 0 ? void 0 : relatedVideos.length) > 1) {
            return route/* route.event */.BC.event(event).episodes();
        }
        if ((0,useTimeState/* isTimeCompleted */.eq)(event)) {
            return flatEvent.pastCtaLink;
        }
        return route/* route.event */.BC.event(event).page();
    }, [
        relatedVideos,
        event,
        flatEvent
    ]);
    var content = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
                    theme: theme/* redTheme */.MN,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                        $background: flatEvent.background,
                        children: [
                            flatEvent.image != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage, {
                                src: flatEvent.image.id,
                                layout: "fill"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTop, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsGridGalleryItem_Date, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                                                    format: "dd.LL.yyyy",
                                                    children: flatEvent.startDate
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsGridGalleryItemVideos, {
                                                relatedVideos: relatedVideos
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            ((ref = flatEvent.type) === null || ref === void 0 ? void 0 : ref.name) != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                                        children: (ref1 = flatEvent.type) === null || ref1 === void 0 ? void 0 : ref1.name
                                                    }),
                                                    flatEvent.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                        children: flatEvent.name
                                                    })
                                                ]
                                            }),
                                            ((ref2 = flatEvent.type) === null || ref2 === void 0 ? void 0 : ref2.name) == null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                                children: flatEvent.name
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: flatEvent.description
                    })
                }),
                flatEvent.tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tags, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagsTitle, {
                            children: [
                                _("EVENT TOPICS"),
                                ": "
                            ]
                        }),
                        flatEvent.tags.map(function(a) {
                            return a.name;
                        }).join(", ")
                    ]
                })
            ]
        });
    }, [
        flatEvent,
        relatedVideos,
        _
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        variants: animationConfig,
        children: link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
            href: link,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLink, {
                children: content
            })
        }) : content
    });
};

// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsGridGallery/index.tsx




function EventsGridGallery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 60px;\n\n  ",
        " {\n    margin-top: 80px;\n  }\n"
    ]);
    EventsGridGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventsGridGallery_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 30px;\n  grid-auto-flow: row;\n  justify-content: center;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n\n  ",
        " {\n    grid-template-columns: 1fr;\n  }\n\n  ",
        " {\n    grid-template-columns: 300px 300px 300px;\n    grid-gap: 40px;\n  }\n"
    ]);
    EventsGridGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var EventsGridGallery_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventsGridGallery__Container",
    componentId: "sc-21380a68-0"
})(EventsGridGallery_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Content = (0,styled_components_browser_esm["default"])(motion/* motion.ol */.E.ol).withConfig({
    displayName: "EventsGridGallery__Content",
    componentId: "sc-21380a68-1"
})(EventsGridGallery_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventsGridGallery_animationConfig = {
    show: {
        transition: {
            staggerChildren: 0.05
        }
    }
};
var EventsGridGallery = function(_param) /*#__PURE__*/ {
    var events = _param.events, props = (0,_object_without_properties/* default */.Z)(_param, [
        "events"
    ]);
    return (0,jsx_runtime.jsx)(EventsGridGallery_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            variants: EventsGridGallery_animationConfig,
            initial: "hide",
            animate: "show",
            children: events.map(function(a) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsGridGalleryItem, {
                    event: a
                }, a.id);
            })
        })
    }));
};


/***/ }),

/***/ 67062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ eventsGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment events on events {\n    id\n    slug\n    form\n    reach\n    startDate\n    endDate\n    background\n    pastCtaLink\n    upcomingCtaLink\n    mailchimpTag\n    logo {\n      id\n    }\n    image {\n      id\n    }\n    translations {\n      howToParticipate\n      upcomingCtaLabel\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n    tags {\n      tags_id {\n        id\n        slug\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    type {\n      id\n      background\n      image {\n        id\n      }\n      logo {\n        id\n      }\n      translations {\n        description\n        excerpt\n        name\n        languages_code {\n          code\n        }\n      }\n      tags {\n        tags_id {\n          id\n          slug\n          translations {\n            name\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var eventsGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 98310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useEventRelatedVideosListQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_modules_videos_graphql_videos_basic_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77336);
/* harmony import */ var src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68591);
/* harmony import */ var src_modules_videos_hooks_useVideosListQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24332);




var useEventRelatedVideosListQuery = function(param) {
    var event = param.event, _limit = param.limit, limit = _limit === void 0 ? -1 : _limit, _detailed = param.detailed, detailed = _detailed === void 0 ? false : _detailed;
    var ref;
    var tagsIDs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref1;
        return (ref = event === null || event === void 0 ? void 0 : (ref1 = event.tags) === null || ref1 === void 0 ? void 0 : ref1.map(function(tag) {
            return tag.tags_id.id;
        }).slice(0, 1)) !== null && ref !== void 0 ? ref : [];
    }, [
        event === null || event === void 0 ? void 0 : event.tags
    ]);
    var videos = (0,src_modules_videos_hooks_useVideosListQuery__WEBPACK_IMPORTED_MODULE_3__/* .useVideosListQuery */ .L)(detailed ? src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__/* .videoDetailsGqlQuery */ .W : src_modules_videos_graphql_videos_basic_query__WEBPACK_IMPORTED_MODULE_1__/* .videosBasicGqlQuery */ .g, {
        filters: {
            tags: {
                tags_id: {
                    id: {
                        _in: tagsIDs
                    }
                }
            },
            status: {
                _eq: "published"
            },
            showcase: {
                _eq: true
            }
        },
        limit: limit,
        sort: [
            "-date_created"
        ]
    }, {
        enabled: tagsIDs.length > 0
    });
    return videos;
};


/***/ }),

/***/ 56760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ fetchEventsList; }
});

// UNUSED EXPORTS: useEventsListQuery

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/modules/events/graphql/events.fragment.ts
var events_fragment = __webpack_require__(67062);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-list.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query EventsList($filters: events_filter, $sort: [String]) {\n    events(filter: $filters, sort: $sort, limit: -1) {\n      ...events\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var eventsListGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject(), events_fragment/* eventsGqlFragment */.g);

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var hooks_useAPIs = __webpack_require__(53100);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventsListQuery.ts







var fetchEventsList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, variables) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventsListGqlQuery, (0,_object_spread/* default */.Z)({
                            sort: [
                                "sort"
                            ]
                        }, variables)).then(function(a) {
                            return a.events;
                        })
                    ];
            }
        });
    });
    return function fetchEventsList(apis, variables) {
        return _ref.apply(this, arguments);
    };
}();
var useEventsListQuery = function() {
    var apis = useAPIs();
    return useQuery(QueryKey.EventsList, function() {
        return fetchEventsList(apis);
    });
};


/***/ }),

/***/ 73082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useFlattenEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70057);




var useFlattenEvent = function(event) {
    var translateFn = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_1__/* .useTranslateItem */ .L)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref, ref1, ref2;
        var translatedEvent = translateFn(event);
        var translatedEventType = event.type != null ? translateFn(event.type) : null;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, translatedEventType, translatedEvent), {
            id: translatedEvent.id,
            name: translatedEvent.name,
            description: translatedEvent.description || (translatedEventType === null || translatedEventType === void 0 ? void 0 : translatedEventType.description) || "",
            excerpt: translatedEvent.excerpt || (translatedEventType === null || translatedEventType === void 0 ? void 0 : translatedEventType.excerpt) || "",
            type: translatedEventType,
            tags: (((ref = event.tags) === null || ref === void 0 ? void 0 : ref.length) > 0 ? event.tags : ((ref1 = event.type) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tags) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? event.type.tags : []).map(function(a) {
                return translateFn(a.tags_id);
            })
        });
    }, [
        event,
        translateFn
    ]);
};


/***/ }),

/***/ 61012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ speakersGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment speakers on people {\n    id\n    avatar {\n      id\n    }\n    name\n    translations {\n      degree\n      title\n      languages_code {\n        code\n      }\n    }\n    country {\n      translations {\n        languages_code {\n          code\n        }\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var speakersGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 3273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ videosBasicFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment videosBasic on videos {\n    id\n    slug\n    date_created\n    thumbnail {\n      id\n    }\n    bodyParts {\n      bodyParts_id {\n        slug\n      }\n    }\n    subjects {\n      subjects_id {\n        slug\n      }\n    }\n    tags {\n      tags_id {\n        id\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    disclaimer\n    source {\n      id\n      url\n      format\n      duration\n      startDate\n      endDate\n    }\n    translations {\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var videosBasicFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 77336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ videosBasicGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);
/* harmony import */ var src_modules_videos_graphql_videos_basic_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3273);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  query VideoBasicQuery($filters: videos_filter, $sort: [String], $limit: Int) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      ...videosBasic\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var videosBasicGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), src_modules_videos_graphql_videos_basic_fragment__WEBPACK_IMPORTED_MODULE_2__/* .videosBasicFragment */ .B);


/***/ }),

/***/ 68591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ videoDetailsGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61012);
/* harmony import */ var src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70763);
/* harmony import */ var src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39738);
/* harmony import */ var src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67561);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query VideoDetailsQuery(\n    $filters: videos_filter\n    $sort: [String]\n    $limit: Int\n  ) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      id\n      slug\n      date_created\n\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      translations {\n        languages_code {\n          code\n        }\n        name\n        description\n        excerpt\n      }\n      audioLanguages {\n        languages_code {\n          code\n          name\n        }\n      }\n      thumbnail {\n        id\n      }\n      products {\n        products_id {\n          ...products\n        }\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n        startDate\n        endDate\n      }\n      tags {\n        tags_id {\n          ...tags\n        }\n      }\n      shortcodes {\n        ...shortcodes\n      }\n      speakers {\n        people_id {\n          ...speakers\n        }\n      }\n      attachments {\n        attachments_id {\n          id\n          type\n          translations {\n            name\n            url\n            description\n            file {\n              id\n            }\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var videoDetailsGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(_templateObject(), src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__/* .productsGqlFragment */ .f, src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__/* .shortcodesGqlFragment */ .U, src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__/* .speakersGqlFragment */ .v, src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__/* .tagsGqlFragment */ .i);


/***/ }),

/***/ 24332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useVideosListQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53100);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19162);






var useVideosListQuery = function(query, variables, options) {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_0__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.VideoList */ .S.VideoList).concat([
        query,
        variables
    ]), /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var directus;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(query, variables).then(function(d) {
                            return d.videos.filter(function(v) {
                                return v;
                            });
                        })
                    ];
            }
        });
    }), options);
};


/***/ })

}]);